import React, { useEffect, useState } from 'react';
import { ShoppingBag } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import api from '../../api/client';
import { useAuth } from '../../context/AuthContext';
import { useVociPortale } from '../../utils/vociPortale';
import { GrigliaRiquadri } from '../../components/dashboardCliente/Riquadro';
import { tipo } from '../../components/dashboardCliente/riquadri';

// Dati personali per i riquadri automatici: si chiede solo ciò che serve ai riquadri presenti
// e alle voci del portale accese (una voce spenta = niente riquadro). Un errore = riquadro nascosto.
const FONTI = {
  CORSO:     ['corso', () => api.get('/widgets/il-mio-corso').then(r => r.data)],
  PAGAMENTI: ['pagamenti', () => api.get('/ricevute/me').then(r => r.data)],
  TESSERA:   ['tessere', () => api.get('/tesseramenti/me').then(r => r.data)],
  FIPAV:     ['fipav', async () => {
    const a = await api.get('/fipav/accesso').then(r => r.data).catch(() => null);
    if (!a?.accesso) return null;
    const [punteggio, richieste] = await Promise.all([
      api.get('/fipav/mio-punteggio').then(r => r.data).catch(() => null),
      api.get('/fipav/richieste/mie').then(r => r.data).catch(() => []),
    ]);
    return punteggio ? { punteggio, richieste } : null;
  }],
  CAMPI:     ['campi', () => api.get('/campi/mie-prenotazioni').then(r => r.data)],
  ORDINI:    ['ordini', () => api.get('/orders').then(r => r.data)],
};

export default function DashboardCliente() {
  const { user } = useAuth();
  const voci = useVociPortale();
  const navigate = useNavigate();
  const [widgets, setWidgets] = useState(null);
  const [dati, setDati] = useState({});

  useEffect(() => { api.get('/widgets').then(r => setWidgets(r.data)).catch(() => setWidgets([])); }, []);

  // riquadri visibili: quelli automatici solo se la loro voce di menu è accesa
  const visibili = (widgets || []).filter(w => { const v = tipo(w.tipo).voce; return !v || voci.attivaPath(v, user); });
  const chiave = visibili.map(w => w.tipo).filter(t => FONTI[t]).sort().join(',');

  useEffect(() => {
    if (!voci.pronto && !voci.fallito) return;
    let vivo = true;
    [...new Set(chiave.split(',').filter(Boolean))].forEach(t => {
      const [k, carica] = FONTI[t];
      carica().then(v => vivo && setDati(d => ({ ...d, [k]: v }))).catch(() => {});
    });
    return () => { vivo = false; };
  }, [chiave, voci.pronto, voci.fallito]);

  const nome = String(user?.nome || '').trim().split(/\s+/)[0];
  const oggi = new Date().toLocaleDateString('it-IT', { weekday: 'long', day: 'numeric', month: 'long' });

  return (
    <div>
      <div className="dc-ciao">
        <div>
          <h1>Ciao{nome ? ` ${nome}` : ''} 👋</h1>
          <p>{oggi}</p>
        </div>
        {voci.attivaPath('/cliente/ordine', user) && (
          <button className="dc-btn" onClick={() => navigate('/cliente/ordine')}><ShoppingBag size={16} /> Nuovo ordine</button>
        )}
      </div>

      {widgets && !visibili.length ? (
        <div className="dc-vuota"><b>Benvenuto nel portale B-Cheers</b>Qui troverai presto novità, avvisi e i tuoi dati.</div>
      ) : (
        <GrigliaRiquadri widgets={visibili} dati={dati} />
      )}
    </div>
  );
}
